export default __webpack_public_path__ + "static/media/Endodontics.2d6c75c6.png";